import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import WorkplaceSelect from '../../../../Workplace/Components/WorkplaceSelect/WokrplaceSelect';

interface Props extends BaseFieldProps {
	managed?: boolean;
	workplaceType?: string;
	workplaceTypes?: string[];
	excludedIds?: string[];
}

const WorkplaceSelectField: React.FC<Props> = props => (
	<BaseField {...props}>
		<WorkplaceSelect
			managed={props.managed}
			workplaceType={props.workplaceType}
			workplaceTypes={props.workplaceTypes}
			excludedIds={props.excludedIds}
		/>
	</BaseField>
);

export default WorkplaceSelectField;
